import { FUNNEL_QUESTIONNAIRE_ELIGIBILITY } from "src/constants/misc";
import type {
  CustomQuestionnaireAnswer,
  CustomQuestionnaireChoice
} from "src/state/QuestionnaireCubit/QuestionnaireState";
import { factoryCampaignInstances } from "./SignupCustomCampaignGenericInstances";
import type FactorySignupCustomCampaign from "./FactorySignupCustomCampaign";

function choiceAnswerMatches(
  override: CustomQuestionnaireAnswer,
  userAnswer: CustomQuestionnaireAnswer
): boolean {
  const overrideChoice = override.fieldValue as CustomQuestionnaireChoice;
  const userChoice = userAnswer.fieldValue as CustomQuestionnaireChoice;
  return userChoice?.choiceId === overrideChoice?.choiceId;
}

function allOverridesMatch(
  campaignOverrides: CustomQuestionnaireAnswer[],
  userAnswers: CustomQuestionnaireAnswer[]
): boolean {
  return campaignOverrides.every((override) => {
    const userAnswer = userAnswers.find(
      (a) => a.questionId === override.questionId
    );
    if (!userAnswer) return false;

    if (override.fieldType === "choice") {
      return choiceAnswerMatches(override, userAnswer);
    }

    return false;
  });
}

/**
 * Find a campaign whose eligibility answerOverrides exactly match the user's answers.
 * Returns the matching campaign instance, or null if no match found.
 */
export function findMatchingCampaignByAnswers(
  userAnswers: CustomQuestionnaireAnswer[]
): FactorySignupCustomCampaign | null {
  if (!userAnswers.length) {
    return null;
  }

  for (const campaign of factoryCampaignInstances()) {
    const overrides =
      campaign.answerOverrides?.[FUNNEL_QUESTIONNAIRE_ELIGIBILITY];

    if (!overrides || overrides.length === 0) {
      continue;
    }

    if (allOverridesMatch(overrides, userAnswers)) {
      return campaign;
    }
  }

  return null;
}
